"use client";
import React from "react";
import Box from "@mui/material/Box";
import Navigation from "@AdbhutByte/utils/components/Navigation";

function Header() {
  return (
    <Box component="header">
      <Navigation />
    </Box>
  );
}

export default Header;
